<div class="layout-menu-container" (click)="onMenuClick($event)">
    <div class="menu-scroll-content">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of getModel(); let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    </div>
</div>
